/**
 * 
 * @Author: Focci
 * @Date: 2023-08-11 14:10:44
 * @Last Modified by: Focci
 * @Last Modified time: 2023-08-11 14:10:44
 */

'use client'

import PropTypes from 'prop-types'
import Link from 'next/link'
import AspectRatioCover from '@comp/AspectRatioCover'
import Table from '@comp/table'
import useApp from '@hook/useApp'
import useTracking from '@hook/useTracking'
import { useLocale, useTranslations } from 'next-intl'
import { formatLang } from '@lib/datetime'
import { propertyDetail } from '@lib/route/house'
import { formatPrice } from '@lib/utils'
import clsx from 'clsx'

function CoverRender({ row }) {
  const { isMobile } = useApp()

  return (
    <div className={clsx(['py-1', isMobile ? 'w-12' : 'w-24'])}>
      <AspectRatioCover
        subtile
        src={row.image}
        width={120}
        height={90}
        alt={row.street}
        className="object-cover rounded-sm"
      />
    </div>
  )
}

function getColumns(th, isMobile, locale, onStreetClick = () => {}) {
  return [
    {
      key: 'image',
      render: CoverRender,
      width: isMobile ? 80 : 160,
      headBackgroundColor: '#f8f8f8'
    },
    {
      key: 'street',
      label: th('streetAddr'),
      width: 200,
      headBackgroundColor: '#f8f8f8',
      render: ({ row }) => (
        <Link 
          onClick={onStreetClick} 
          href={propertyDetail(row.slug, locale)} 
          className="text-primary underline"
        >
          {/* <Number tagName="span">
            {row.street}
          </Number> */}
          {row.street}
        </Link>
      )
    },
    {
      key: 'distance',
      label: th('distance'),
      sortable: true,
      width: 80,
      headBackgroundColor: '#f8f8f8',
      render: ({ row }) => (
        <span>
          {
            row.distance !== undefined
              ? `${(row.distance / 1000).toFixed(2)} km`
              : '-'
          }
        </span>
      )
    },
    {
      key: 'bedrooms',
      label: th('bedroomCount'),
      headBackgroundColor: '#f8f8f8',
      sortable: true,
    },
    {
      key: 'bathrooms',
      label: th('bathroomCount'),
      headBackgroundColor: '#f8f8f8',
      sortable: true,
    },
    {
      key: 'floorarea',
      label: th('buildingArea'),
      headBackgroundColor: '#f8f8f8',
      sortable: true,
      render: ({ row }) => (
        <span>
          {`${row.floorarea}m`}
          <sup>2</sup>
        </span>
      )
    },
    {
      key: 'soldData',
      label: th('soldDatetime'),
      sortable: true,
      width: 120,
      headBackgroundColor: '#f8f8f8',
      render: ({ row }) => (
        formatLang(parseFloat(row.soldData), th('yearMonthDay'), locale)
      )
    },
    {
      key: 'soldPrice',
      label: th('soldPrice'),
      sortable: true,
      headBackgroundColor: '#f8f8f8',
      render: ({ row }) => (
        // eslint-disable-next-line max-len
        // <Number tagName="span">{row.soldPrice !== null ? `$${formatPrice(row.soldPrice)}` : '-'}</Number>
        !row.soldPrice ? '-' : `$${formatPrice(row.soldPrice)}` 
      )
    },
    {
      key: 'source',
      label: th('dataSource'),
      width: 180,
      headBackgroundColor: '#f8f8f8',
      // align: 'right'
    }
  ]
}

export default function SoldTable({
  data = [],
  house,
}) {
  const { isMobile } = useApp()
  const locale = useLocale()
  const th = useTranslations('house')

  const { pushTrackListingClick } = useTracking()
  const columns = getColumns(
    th, 
    isMobile, 
    locale,
    () => pushTrackListingClick('sold_nearby-other_house', house)
  )

  return (
    <Table
      bordered
      data={data.slice(0, 5)}
      columns={columns}
      defaultOrderProp="soldData"
      sortOrder="desc"
      height="32.8rem"
    />
  )
}

SoldTable.propTypes = {
  data: PropTypes.array,
  house: PropTypes.object,
}
